import { Building2 } from 'lucide-react'
import { useAuthStore } from '@/lib/auth-store'

/**
 * Display-only organisation badge at the top of the sidebar. Currently each
 * user belongs to a single organisation (or none); when multi-org membership
 * lands, this component will graduate into a real switcher dropdown
 * mirroring `ArtistSwitcher`.
 */
export function OrganisationSwitcher() {
  const user = useAuthStore((s) => s.user)
  if (!user?.organisationId) return null

  return (
    <div className="flex items-center gap-2 rounded-md border border-ovation-ink/15 bg-white px-3 py-2 text-sm">
      <Building2 className="h-4 w-4 flex-shrink-0 text-ovation-muted" />
      <div className="min-w-0 flex-1">
        <div className="truncate text-[10px] uppercase tracking-wider text-ovation-muted">
          Organisation
        </div>
        <div className="truncate font-medium">
          {user.organisationName ?? 'Organisation'}
        </div>
      </div>
      {user.orgRole && (
        <span className="rounded bg-ovation-paper/60 px-1.5 py-0.5 text-[10px] uppercase tracking-wider text-ovation-muted">
          {user.orgRole}
        </span>
      )}
    </div>
  )
}
